import axios from 'axios';

import * as actionTypes from '../../types/tickets';
import {
  getTicketViewUrl,
  getTicketsPagination,
  getTicketConfig,
  addTicketUrl,
  getTicketsUrl,
  sendMessageUrl,
  unreadMessageUrl,
  closeTicketUrl,
  deleteTicketUrl,
  deleteMessageUrl,
  changeMassStatus,
  changeTicketMessage,
  assignAdminUrl,
  getTicketsStatusesCounts,
  getTicketsStaffCounts,
  markAsSpamTicketUrl,
} from '../../../services/endpoints/tickets';

/**
 * @function
 * @name clearTicketsFilters
 * @description - Очистка фильтров
 */
export const clearTicketsFilters = () => (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_FILTERS });
};

/**
 * @function
 * @name getTicketsList
 * @description Листинг страницы
 * @param {object} payload - Объект query листинга(фильтров)
 */
export const getTicketsList = (payload, showLoader = true) => async (dispatch, getState) => {
  if (showLoader) dispatch({ type: actionTypes.GET_LIST });
  try {
    const response = await getTicketsUrl(payload);
    const { data } = response;

    let prepareData = data;

    // Stop hide unread tickets
    const { root } = getState();
    if (payload?.unread === '1' && root?.data?.tickets?.length && !showLoader) {
      prepareData = {
        ...data,
        tickets: root?.data?.tickets?.map((ticket) => {
          if (!data?.tickets?.map((t) => t.id)?.includes(ticket.id)) {
            return {
              ...ticket,
              unread: false,
            };
          }
          return ticket;
        }),
      };
    }

    dispatch({
      type: actionTypes.GET_LIST_SUCCESS,
      data: prepareData,
    });
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }

    dispatch({
      type: actionTypes.GET_LIST_ERROR,
      error,
    });
  }
};

/**
 * @function
 * @name getTicketsPaginationAction
 * @description Пагинация
 * @param {object} payload - Объект query листинга(фильтров)
 */
export const getTicketsPaginationAction = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_PAGINATION });

  try {
    const response = await getTicketsPagination(payload);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_PAGINATION_SUCCESS,
      data: data.pagination,
    });

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }

    dispatch({
      type: actionTypes.GET_PAGINATION_ERROR,
      error,
    });
  }
};

/**
 * @function
 * @name getTicketsConfigAction
 * @description Конфигурация страницы
 */
export const getTicketsConfigAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_CONFIG });

  try {
    const response = await getTicketConfig();
    const { data } = response;

    dispatch({
      type: actionTypes.GET_CONFIG_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }

    dispatch({
      type: actionTypes.GET_CONFIG_ERROR,
      error,
    });
  }
};

/**
 * @function
 * @name getTicketsStaffCountsAction
 * @description Каунтеры для персонала
 */
export const getTicketsStaffCountsAction = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_STAFF });

  try {
    const response = await getTicketsStaffCounts(payload);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_STAFF_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    dispatch({
      type: actionTypes.GET_STAFF_ERROR,
      error,
    });
  }
};

/**
 * @function
 * @name getTicketsStatusesCountsAction
 * @description Каунтеры для статусов
 */
export const getTicketsStatusesCountsAction = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_STATUSES_COUNTS });

  try {
    const response = await getTicketsStatusesCounts(payload);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_STATUSES_COUNTS_SUCCESS,
      data,
      field: 'statuses',
    });

    return response;
  } catch (error) {
    dispatch({
      type: actionTypes.GET_STATUSES_COUNTS_ERROR,
      error,
    });
  }
};

/**
 * @function
 * @name addTicketAction
 * @description Добавление тикета
 * @param {object} payload
 */
export const addTicketAction = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.ADD_TICKET });

  try {
    await addTicketUrl(payload);
    dispatch({
      type: actionTypes.ADD_TICKET_SUCCESS,
    });
  } catch (error) {
    dispatch({ type: actionTypes.ADD_TICKET_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function
 * @name getTicketView
 * @description Получение данных тикета по id
 * @param {number} id
 */
export const getTicketView = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_TICKET_VIEW });

  try {
    const response = await getTicketViewUrl(id);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_TICKET_VIEW_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({ type: actionTypes.GET_TICKET_VIEW_ERROR, error });
  }
};

/**
 * @function
 * @name sendMessage
 * @description Отправка сообщения
 * @param {number} id
 * @param {string} message
 */
export const sendMessage = (id, message, files) => async (dispatch) => {
  dispatch({ type: actionTypes.SEND_MESSAGE });
  try {
    await sendMessageUrl(id, message, files);
    dispatch({ type: actionTypes.SEND_MESSAGE_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.SEND_MESSAGE_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function
 * @name unreadTicket
 * @description Пометить как не прочитанное сообщение
 * @param {number} id
 */
export const unreadTicket = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.UNREAD_MESSAGE });
  try {
    await unreadMessageUrl(id);
    dispatch({ type: actionTypes.UNREAD_MESSAGE_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.UNREAD_MESSAGE_ERROR, error });
  }
};

/**
 * @function
 * @name closeTicket
 * @description Закрыть тикет
 * @param {number} id
 * @param {boolean} lock
 */
export const closeTicket = (id, lock) => async (dispatch) => {
  dispatch({ type: actionTypes.CLOSE_TICKET });
  try {
    await closeTicketUrl(id, lock);
    dispatch({ type: actionTypes.CLOSE_TICKET_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.CLOSE_TICKET_ERROR, error });
  }
};

/**
 * @function
 * @name closeTicket
 * @description Пометить тикет как спам
 * @param {number} id
 * @param {boolean} lock
 */
export const markAsSpamTicket = (id, lock) => async (dispatch) => {
  dispatch({ type: actionTypes.MARK_AS_SPAM_TICKET });
  try {
    await markAsSpamTicketUrl(id, lock);
    dispatch({ type: actionTypes.MARK_AS_SPAM_TICKET_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.MARK_AS_SPAM_TICKET_ERROR, error });
  }
};

/**
 * @function
 * @name deleteTicket
 * @description Удалить тикет
 * @param {number} id
 */
export const deleteTicket = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_TICKET });
  try {
    await deleteTicketUrl(id);
    dispatch({ type: actionTypes.DELETE_TICKET_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.DELETE_TICKET_ERROR, error });
  }
};

/**
 * @function
 * @name deleteMessage
 * @description Удалить сообщение
 * @param {number} messageID
 */
export const deleteMessage = (messageID) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_MESSAGE });

  try {
    await deleteMessageUrl(messageID);
    dispatch({
      type: actionTypes.DELETE_MESSAGE_SUCCESS,
    });
  } catch (error) {
    dispatch({ type: actionTypes.DELETE_MESSAGE_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function
 * @name changeMassStatusAction
 * @description Массовая смена статусов
 * @param {object} payload
 */
export const changeMassStatusAction = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.CHANGE_MASS_STATUS });

  try {
    await changeMassStatus(payload);
    dispatch({
      type: actionTypes.CHANGE_MASS_STATUS_SUCCESS,
    });
  } catch (error) {
    dispatch({ type: actionTypes.CHANGE_MASS_STATUS_ERROR, error });
  }
};

/**
 * @function
 * @name changeTicketMessageAction
 * @description Изменить сообщение тикета
 * @param {number} id
 * @param {string} message
 */
export const changeTicketMessageAction = (id, message) => async (dispatch) => {
  dispatch({ type: actionTypes.CHANGE_TICKET_MESSAGE });

  try {
    await changeTicketMessage(id, message);
    dispatch({
      type: actionTypes.CHANGE_TICKET_MESSAGE_SUCCESS,
      payload: { id, message },
    });
  } catch (error) {
    dispatch({ type: actionTypes.CHANGE_TICKET_MESSAGE_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function
 * @name clearTicketView
 * @description Очистка стейта для тикета
 */
export const clearTicketView = () => (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_TICKET_VIEW });
};

/**
 * @function
 * @name setActiveTicketForView
 * @description Активный тикет
 * @param {number} id
 */
export const setActiveTicketForView = (id) => async (dispatch) => {
  dispatch({
    type: actionTypes.SET_ACTIVE_TICKET_FOR_TICKET_VIEW,
    payload: id,
  });
};

/**
 * @function
 * @name assignAdmin
 * @description назначить админа на тикет
 * @param {number} ticketId
 * @param {number} adminId
 */
export const assignAdmin = (ticketId, adminId) => async (dispatch) => {
  dispatch({ type: actionTypes.ASSIGN_TICKET });

  try {
    await assignAdminUrl(ticketId, adminId);
    dispatch({ type: actionTypes.ASSIGN_TICKET_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.ASSIGN_TICKET_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};
